<template>
  <div class="filter-item">
    <label :for="filter.name">{{ filter.label }}</label>
    <select v-if="filter.isDropdown" :name="filter.name" :value="localInput" @input="onInput">
      <option value="">All</option>
      <option
        v-for="(option, index) in dropdownOptions[filter.dropdownOptionsName]"
        :key="`${filter.dropdownOptionsName}_${index}`"
        :value="option.id ?? option"
      >
        {{ option.name || option }}
      </option>
    </select>
    <input
      v-if="filter.isDate"
      type="date"
      :name="filter.name"
      :value="localInput"
      @input="onInput"
    />
    <input
      v-if="filter.isText"
      type="text"
      :name="filter.name"
      :placeholder="filter.placeholder"
      :value="localInput"
      @input="onInputText"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from 'vue';
import debounce from 'lodash/debounce';

export default defineComponent({
  name: 'FilterItem',
  props: {
    value: String,
    filter: Object,
    dropdownOptions: Object,
  },
  emits: ['input'],
  setup(props, { emit }) {
    const localInput = ref<string>();

    const onInput = (e: { target: HTMLInputElement }) => {
      const value = e.target.value;

      emit('input', value, props.filter?.name);
    };

    const onInputText = debounce((e: { target: HTMLInputElement }) => {
      const value = e.target.value;
      emit('input', value, props.filter?.name);
    }, 500);

    // re-assign localInput value if props.value updated
    // TODO: extract this logic to share with other components
    watch(
      () => props.value,
      (value, preValue) => {
        if (value !== preValue && localInput.value !== props.value) {
          localInput.value = props.value;
        }
      }
    );

    onMounted(() => {
      localInput.value = props.value;
    });

    return {
      localInput,
      onInput,
      onInputText,
    };
  },
});
</script>

<style lang="scss">
.filter-item {
  display: flex;
  flex-direction: column;
  margin-right: var(--space-4);
  width: 14rem;

  label {
    font-size: var(--font-size-12);
  }

  input,
  select {
    font-size: var(--font-size-14);
    padding: var(--space-1) var(--space-2);
    height: 2rem;
  }
}
</style>
